export const FRIENDLY_PARTNER_ID_FIELD = 'zendeskDomain';
